import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{! @glint-nocheck: not yet converted to GTS }}\n{{outlet}}",{ moduleName: "garaje/pods/protect/announcements/template.hbs" })